import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Naver(){
    const { pathname } = useLocation();

    useEffect(() => {
        if (!window.wcs_add) window.wcs_add = {};
        window.wcs_add["wa"] = "s_257328b751ec";

        if (window.wcs) {
            window.wcs.inflow("amanorent.co.kr");
            window.wcs_do();
        }
    }, [pathname]);

    return null;
}